/**
 * Role-Based Route Component
 * 
 * Wraps routes that require specific roles.
 * Redirects unauthorized users to 403 page.
 */

import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const RoleRoute = ({ children, role, anyRole = [] }) => {
    const { user, loading, authenticated } = useAuth();

    if (loading) {
        return (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', backgroundColor: '#FBFBF9' }}>
                <div style={{
                    width: '36px', height: '36px',
                    border: '3px solid #E6E5E1',
                    borderTopColor: '#1F7D91',
                    borderRadius: '50%',
                    animation: 'spin 0.8s linear infinite',
                }} />
            </div>
        );
    }

    if (!authenticated) {
        return <Navigate to="/loginNew" replace />;
    }

    // Check if user has required role
    const hasRequiredRole = role
        ? user?.role === role
        : anyRole.length > 0
            ? anyRole.includes(user?.role)
            : true;

    if (!hasRequiredRole) {
        return <Navigate to="/forbidden" replace />;
    }

    return children;
};

export default RoleRoute;
